export const customerOrigin = {
  newsletter: "newsletter",
  newprocess: "new-process",
};
